export class AuthenticationRevokeModel {
  public Token: string = '';
}
